import ApiRequest from 'core-api';
import { API_ADDRESS } from 'src/enums/apiInfo';
import { RoutePath } from 'src/router/routePath';

export const apiRequest = new ApiRequest({
  baseUrl: API_ADDRESS,
  onUnauthenticated: () => window.location.replace(RoutePath.LOGIN),
});
